import {
  _findSpaceList,
  _findAllList,
  _addSpace,
  _addOrEdit,
  _findLog,
  _findById,
  _findUserDmRelationById,
  _findSignInById,
  _findAllBgTemplate,
  _findAllBgTemplateV2,
  _findAllMusicTemplate,
  _findDeadLog,
  _editCemeteryById,
  _editById,
  _editUpdateStateById,
  _editUploadStateById,
  _editVisitorFrozenById,
  _editSpaceFrozenById,
  _getUrlDataSource,
  _cancelUpdateStateById,
  _getUrlConnectionCode,
  _getOssFileState,
  _cancelUploadStateById,
  _editUploadById,
  _findUploadByDmId,
  _saveLog,
  _findAppInfoAll,
  _editDeadNameById,
  _getWxPayOrder,
  _delUploadById,
  _findPhotoCategory,
  _addOrEditPhotoCategory,
  _delPhotoCategory,
  _findPhotoByDmId,
  _findPhotoByCategoryId,
  _addPhotoByCategoryId,
  _delPhotoById,
  _editPhotoRemark,
  _editPhotoPosition,
  _findMovePhotoCategory,
  _movePhoto,
  _getUserCount,
  _dragPhoto,
  _getCoverVideo,
  _getClaimCodeUrl,
  _getClaimCodeUrlAll,
  _getLifeAlbumByDmId,
  _findLifeAlbumPhotoAllByDmId,
  _addLifeAlbumPhotoByDmId,
  _draggableLifeAlbumPhoto,
  _delLifeAlbumPhotoByIds,
  _findLifeAlbumTemplateBg,
  _findLifeAlbumTemplateMusic,
  _findLifeAlbumSubtitle1,
  _findLifeAlbumSubtitle2,
  _findLifeAlbumSubtitle3,
  _addLifeAlbumByDmId,
  _addLifeAlbumListener,
  _cleanLifeAlbumByDmId,
  _updateLifeAlbumStateByDmId,
  _findLifeAlbumPhotoFrameById,
  _editLifeAlbumPhotoCropperUrl,
  _cancelLifeAlbumPhotoCropperUrl,
  _editLifeAlbumPhotoAiUrl,
  _confirmLifeAlbumPhotoAiUrl,
  _replaceLifeAlbumPhotoAiUrl,
  _replaceLifeAlbumPhotoAiUrlAll,
  _uploadLifeAlbumVideoToDmPhoto,
  _downloadLifeAlbumVideo,
  _compositeLifeAlbumPhotoAiHeadPic,
  _callLifeAlbumPhotoAi,
  _uploadLifeAlbumPhotoToDmPhoto,
} from '@/api/Space'
import {
  catchErr
} from '@/utils/utils'
import {
  Message,
  MessageBox,
} from 'element-ui'

function messageBoxDeadManDel(){
  MessageBox.confirm("纪念堂已失效，请返回纪念堂列表页面刷新", "提示", {
    type: "warning",
    showCancelButton: false,
  }).then(() => {
    window.opener = null;
    window.open("about:blank", "_top").close();
  }).catch(() => {
    window.opener = null;
    window.open("about:blank", "_top").close();
  });
}

export default {

  // 获取纪念堂列表
  async findSpaceList({
    commit,
    state
  }) {

    let paramsAll = {}
    let params = {}
    if (state.spaceManagement.title == 0) {
      state.spaceManagement.spaceSearchForm.visitorFrozen = ''
      state.spaceManagement.spaceSearchForm.spaceFrozen = ''
      paramsAll.pageInfo = state.spaceManagement.pageManagementAll
      params.type = 1
    } else if (state.spaceManagement.title == 1) {
      state.spaceManagement.spaceSearchForm.visitorFrozen = 1
      state.spaceManagement.spaceSearchForm.spaceFrozen = ''
      paramsAll.pageInfo = state.spaceManagement.pageManagementV
      params.type = 2
    } else if (state.spaceManagement.title == 2) {
      state.spaceManagement.spaceSearchForm.visitorFrozen = ''
      state.spaceManagement.spaceSearchForm.spaceFrozen = 1
      paramsAll.pageInfo = state.spaceManagement.pageManagementS
      params.type = 3
    } else {
      state.spaceManagement.spaceSearchForm.visitorFrozen = 0
      state.spaceManagement.spaceSearchForm.spaceFrozen = 0
      paramsAll.pageInfo = state.spaceManagement.pageManagementAll
      params.type = 1
    }
    if (state.spaceManagement.spaceSearchForm.date != null && state.spaceManagement.spaceSearchForm.date.length >= 2) {
      params.createDateStart = state.spaceManagement.spaceSearchForm.date[0];
      params.createDateEnd = state.spaceManagement.spaceSearchForm.date[1];
    }
    params.code = state.spaceManagement.spaceSearchForm.code;
    //let name = state.spaceManagement.spaceSearchForm.name
    //name = name.replace(/(^\s*)|(\s*$)/g, "");
    //params.name = name;
    if (state.spaceManagement.spaceSearchForm.codeOrName != '') {
      let codeOrName = state.spaceManagement.spaceSearchForm.codeOrName
      codeOrName = codeOrName.replace(/(^\s*)|(\s*$)/g, "");
      params.codeOrName = codeOrName;
    }
    params.spaceFrozen = state.spaceManagement.spaceSearchForm.spaceFrozen;

    params.visitorFrozen = state.spaceManagement.spaceSearchForm.visitorFrozen;
    if (state.spaceManagement.spaceSearchForm.status != 0) {
      if (state.spaceManagement.spaceSearchForm.status == 4) {
        params.spaceFrozen = 1
      } else {
        params.status = state.spaceManagement.spaceSearchForm.status;
      }
    }

    if (state.spaceManagement.spaceSearchForm.fhId != 0) {
      params.fhId = state.spaceManagement.spaceSearchForm.fhId;
    }

    if (state.spaceManagement.spaceSearchForm.updateState != 5) {
      params.updateState = state.spaceManagement.spaceSearchForm.updateState;
    }
    if (state.spaceManagement.spaceSearchForm.loginMobileState != null) {
      params.loginMobileState = state.spaceManagement.spaceSearchForm.loginMobileState;
    }
    //params.undertakerTel = state.spaceManagement.spaceSearchForm.undertakerTel;
    params.familyTel = state.spaceManagement.spaceSearchForm.undertakerTel;
    params.amUseDate = state.spaceManagement.spaceSearchForm.amUseDate;
    let remarkName = state.spaceManagement.spaceSearchForm.remarkName;
    remarkName = remarkName.replace(/(^\s*)|(\s*$)/g, "");
    params.remarkName = remarkName;

    if (state.spaceManagement.spaceSearchForm.appShortName != '') {
      if (state.spaceManagement.spaceSearchForm.appShortName == state.spaceManagement.spaceSearchForm.appShortNameChoice) {
        params.unitId = state.spaceManagement.spaceSearchForm.appShortNameChoiceId
      } else {
        let isHave = false
        state.spaceManagement.findAppInfoAllList.forEach(item => {
          if (item.appShortName == state.spaceManagement.spaceSearchForm.appShortName) {
            params.unitId = item.appId
            isHave = true
          }
        })
        if (!isHave) {
          params.unitId = -100
        }
      }
    }

    paramsAll.data = params;

    let [err, res] = await catchErr(_findSpaceList(paramsAll));
    if (err) {
      Message.error(err.message || '系统异常');
    } else if (res) {
      console.log(res)
      if (res.data == undefined || res.data.length == 0) {
        state.spaceManagement.number = '0条';
        commit('SETTOTALLIST', [])
      } else {
        state.spaceManagement.number = res.pageInfo.total + '条';
        res.data.forEach((_t) => {
          _t.createTimeS = _t.createTime.substring(0, 10)
          _t.createTimeE = _t.createTime.substring(11, _t.createTime.length)
          if (_t.cemetery != undefined && _t.cemeteryUnitShortName != undefined) {
            if (_t.cemetery.length + _t.cemeteryUnitShortName.length > 8) {
              _t.cemeteryName = _t.cemeteryUnitShortName + _t.cemetery
              _t.cemeteryName = _t.cemeteryName.substring(0, 8) + '...'
            } else {
              _t.cemeteryName = _t.cemeteryUnitShortName + _t.cemetery
            }
          } else {
            _t.cemeteryName = '—'
          }

          let k = _t.spaceFrozen - 0
          if (k == 1) {
            _t.statusNameLock = '已冻结'
          } else if (k == 2) {
            _t.statusNameLock = '申请解冻'
          } else {
            _t.statusNameLock = ''
          }

          if (_t.undertakerName != undefined && _t.undertakerName != '') {

          } else {
            _t.undertakerName = '—'
          }

          if (_t.remarkName != undefined && _t.remarkName != '') {

          } else {
            _t.remarkName = '—'
          }

          if (_t.remarkBirthday != undefined && _t.remarkBirthday != '') {

          } else {
            _t.remarkBirthday = '—'
          }

          if (_t.remarkDeadday != undefined && _t.remarkDeadday != '') {

          } else {
            _t.remarkDeadday = '—'
          }

          if (_t.unitShortName != undefined && _t.unitShortName != '') {

          } else {
            _t.unitShortName = '—'
          }

          if (_t.undertakerTel != undefined && _t.undertakerTel != '') {

          } else {
            _t.undertakerTel = '—'
          }

          //_t.name = _t.name.replace(' ', "&nbsp;")
          if (_t.foreverState == 1) {
            _t.statusName = '永久';
          } else {
            let m = _t.status - 0;
            switch (m) {
              case 1:
                _t.statusName = '有效';
                break;
              case 2:
                _t.statusName = '过期';
                break;
              default:
            }
          }
          let kt = _t.visitorFrozen - 0;
          switch (kt) {
            case 1:
              _t.visitorFrozenName = '已冻结';
              break;
            case 0:
              _t.visitorFrozenName = '';
              break;
            case 2:
              _t.visitorFrozenName = '申请解冻';
              break;
            default:
          }
          if (_t.amList != undefined && _t.amList.length != 0) {
            _t.amList.forEach((item) => {
              if (item.fhType == 1) {
                //殡仪馆
                _t.nameA = item.unitShortName + item.fhName;
                //_t.dateA = item.useDate +' '+item.startTime.substring(0,5)+'-'+item.endTime.substring(0,5);
                _t.dateA = item.startTime.substring(0, 5) + '-' + item.endTime.substring(0, 5);
                if (_t.amList.length == 1) {
                  _t.nameB = '—';
                  _t.dateB = '—';
                }
              } else if (item.fhType == 2) {
                //陵园
                _t.nameB = item.unitShortName + item.fhName;
                //_t.dateB = item.useDate +' '+item.startTime.substring(0,5)+'-'+item.endTime.substring(0,5);
                _t.dateB = item.startTime.substring(0, 5) + '-' + item.endTime.substring(0, 5);
                if (_t.amList.length == 1) {
                  _t.nameA = '—';
                  _t.dateA = '—';
                }
              }
            });
          } else {
            _t.nameA = '—';
            _t.dateA = '—';
            _t.nameB = '—';
            _t.dateB = '—';
          }
        });
        commit('SETTOTALLIST', res.data)
      }
      if (state.spaceManagement.title == 0) {
        commit('SETPAGEMANAGEMENTALL', res.pageInfo)
      } else if (state.spaceManagement.title == 1) {
        commit('SETPAGEMANAGEMENTV', res.pageInfo)
      } else if (state.spaceManagement.title == 2) {
        commit('SETPAGEMANAGEMENTS', res.pageInfo)
      } else {
        commit('SETPAGEMANAGEMENTALL', res.pageInfo)
      }
    }
    return true;
  },

  // 获取告别厅列表-全部
  async findAllList({
    commit,
    state
  }) {
    let params = {}
    if (JSON.parse(window.sessionStorage.getItem("binyi_cms_loginInfo")).unitId != null &&
      JSON.parse(window.sessionStorage.getItem("binyi_cms_loginInfo")).unitId != 0) {
      params.data = JSON.parse(window.sessionStorage.getItem("binyi_cms_loginInfo")).unitId
    }
    let [err, res] = await catchErr(_findAllList(params));
    if (err) {
      Message.error(err.message || '系统异常');
    } else if (res) {
      console.log(res)
      commit('SETFAREWELLOFFICELIST', res.data)
    }
    return true;
  },

  // 获取单位信息列表（全部）
  async findAppInfoAll({
    commit,
    state
  }) {
    let params = {}
    let [err, res] = await catchErr(_findAppInfoAll(params));
    if (err) {
      Message.error(err.message || '系统异常');
    } else if (res) {
      console.log(res)
      commit('SETFINDAPPINFOALLLIST', res.data)
    }
    return true;
  },

  // 获取告别厅列表-全部-新建
  async findAllListCreate({
    commit,
    state
  }) {
    let params = {}
    if (JSON.parse(window.sessionStorage.getItem("binyi_cms_loginInfo")).unitId != null &&
      JSON.parse(window.sessionStorage.getItem("binyi_cms_loginInfo")).unitId != 0) {
      params.data = JSON.parse(window.sessionStorage.getItem("binyi_cms_loginInfo")).unitId
    }
    let [err, res] = await catchErr(_findAllList(params));
    if (err) {
      Message.error(err.message || '系统异常');
    } else if (res) {
      console.log(res)
      commit('SETFAREWELLOFFICELISTC', res.data)
    }
    return true;
  },

  // 新建纪念堂信息
  async addSpace({
    commit,
    state,
    dispatch
  }) {
    let params = {}
    let name = state.spaceManagement.createForm.name
    name = name.replace(/(^\s*)|(\s*$)/g, "");
    params.name = name;
    //params.undertakerTel = state.spaceManagement.createForm.undertakerTel
    //params.deadName = state.spaceManagement.createForm.deadName
    // if (state.spaceManagement.createForm.undertakerName != '') {
    //   let undertakerName = state.spaceManagement.createForm.undertakerName;
    //   undertakerName = undertakerName.replace(/(^\s*)|(\s*$)/g, "");
    //   if (undertakerName != '') {
    //     params.undertakerName = undertakerName;
    //   }
    // }
    if (state.spaceManagement.createForm.coverUrl != '' && state.spaceManagement.createForm.coverType == 0) {
      params.coverUrl = state.spaceManagement.createForm.coverUrl;
      //let baseImage = state.spaceManagement.createForm.coverImages[1];
      // params.coverPhoto = {
      //   photoUrl: baseImage.url,
      //   type: 1,
      //   source: 2,
      //   size: baseImage.size / 1000
      // };
    }
    let [err, res] = await catchErr(_addSpace({
      data: params
    }));
    if (err) {
      Message.error(err.message || '系统异常');
    } else if (res) {
      return res
    }
    return true;
  },

  // 新建/编辑告别会
  async addOrEdit({
    commit,
    state,
    dispatch
  }, params) {
    params.fhId = state.spaceManagement.officeForm.office;
    params.useDate = state.spaceManagement.officeForm.date;
    params.startTime = state.spaceManagement.officeForm.startTime + ":00";
    params.endTime = state.spaceManagement.officeForm.endTime + ":00";
    let [err, res] = await catchErr(_addOrEdit({
      data: params,
    },params.dmId));
    if (err) {
      if(err.status == 1098){
        return err
      }
      Message.error(err.message || '系统异常');
    } else if (res) {
      return res
    }
    return true;
  },


  // 日志列表
  async findLog({
    commit,
    state,
    dispatch
  }, params) {
    params.createUserName = state.spaceManagement.spaceLogForm.createUserName;
    params.content = state.spaceManagement.spaceLogForm.content;
    if (state.spaceManagement.spaceLogForm.date != null && state.spaceManagement.spaceLogForm.date.length >= 2) {
      params.createDateStart = state.spaceManagement.spaceLogForm.date[0];
      params.createDateEnd = state.spaceManagement.spaceLogForm.date[1];
    }
    let [err, res] = await catchErr(_findLog({
      data: params,
      pageInfo: state.spaceManagement.pageManagementLog
    },params.dmId));
    if (err) {
      if(err.status == 1098){
        return err
      }
      Message.error(err.message || '系统异常');
    } else if (res) {
      console.log(res)
      if (res.data == undefined || res.data.length == 0) {
        state.spaceManagement.numberLog = '0条';
        commit('SETLOGLIST', [])
        commit('SETPAGEMANAGEMENTLOG', res.pageInfo)
      } else {
        state.spaceManagement.numberLog = res.pageInfo.total + '条';
        commit('SETLOGLIST', res.data)
        commit('SETPAGEMANAGEMENTLOG', res.pageInfo)
      }
    }
    return true;
  },


  async findUploadByDmId({
    commit,
    state,
    dispatch
  }, params) {
    params.createAdminName = state.spaceDetails.spaceLogForm.createUserName;
    if (state.spaceDetails.spaceLogForm.date != null && state.spaceDetails.spaceLogForm.date.length >= 2) {
      params.createDateStart = state.spaceDetails.spaceLogForm.date[0];
      params.createDateEnd = state.spaceDetails.spaceLogForm.date[1];
    }
    let [err, res] = await catchErr(_findUploadByDmId({
      data: params,
      pageInfo: state.spaceDetails.pageManagementLog
    },params.dmId));
    if (err) {
      if(err.status == 1098){
        return err
      }
      Message.error(err.message || '系统异常');
    } else if (res) {
      console.log(res)
      if (res.data == undefined || res.data.length == 0) {
        state.spaceDetails.numberLog = '0条';
        commit('SETLOGLISTUPDATE', [])
        commit('SETPAGEMANAGEMENTLOGUPDATE', res.pageInfo)
      } else {
        state.spaceDetails.numberLog = res.pageInfo.total + '条';
        res.data.forEach((_t) => {
          _t.claimState = state.spaceDetails.details.claimState == 0 ? false : true;
          _t.uploadState = state.spaceDetails.uploadState;
          _t.photoCategoryNameNew = _t.photoCategoryName != undefined ? _t.photoCategoryName : '—'
        })
        commit('SETLOGLISTUPDATE', res.data)
        commit('SETPAGEMANAGEMENTLOGUPDATE', res.pageInfo)
      }
    }
    return true;
  },


  // 获取纪念堂详情
  async findById({
    commit,
    state,
    dispatch
  }, params) {
    let [err, res] = await catchErr(_findById({
      data: params
    },params));
    if (err) {
      if(err.status == 1098){
        return err
      }
      Message.error(err.message || '系统异常');
    } else if (res) {
      console.log(res)
      commit('SETDETAILS', res.data)
      return res;
    }
    return true;
  },

  //只更新中间
  async findByIdMiddle({
    commit,
    state,
    dispatch
  }, params) {
    let [err, res] = await catchErr(_findById({
      data: params
    },params));
    if (err) {
      if(err.status == 1098){
        return err
      }
      Message.error(err.message || '系统异常');
    } else if (res) {
      console.log(res)
      commit('SETDETAILSMIDDLE', res.data)
      return res;
    }
    return true;
  },

  // 获取纪念堂详情只更新一半
  async findByIdHalf({
    commit,
    state,
    dispatch
  }, params) {
    let [err, res] = await catchErr(_findById({
      data: params
    },params));
    if (err) {
      if(err.status == 1098){
        return err
      }
      Message.error(err.message || '系统异常');
    } else if (res) {
      console.log(res)
      commit('SETDETAILSHALF', res.data)
      return res;
    }
    return true;
  },

  async findByIdAnother({
    commit,
    state,
    dispatch
  }, params) {
    let [err, res] = await catchErr(_findById({
      data: params
    },params));
    if (err) {
      if(err.status == 1098){
        return err
      }
      Message.error(err.message || '系统异常');
    } else if (res) {
      console.log(res)
      return res;
    }
    return true;
  },

  // 获取纪念堂详情-成员列表
  async findUserDmRelationById({
    commit,
    state,
    dispatch
  }, params) {
    let [err, res] = await catchErr(_findUserDmRelationById({
      data: params,
    }));
    if (err) {
      Message.error(err.message || '系统异常');
    } else if (res) {
      console.log(res)
      if (res.data == undefined || res.data.length == 0) {
        commit('SETPEOPLELIST', [])
      } else {
        //state.spaceDetails.leaveWordNumber = res.data.length;
        commit('SETPEOPLELIST', res.data)
      }
    }
    return true;
  },

  // 获取纪念堂详情-留言列表
  async findSignInById({
    commit,
    state,
    dispatch
  }, params) {
    let [err, res] = await catchErr(_findSignInById({
      data: params,
      pageInfo: state.spaceDetails.pageManagement
    }));
    if (err) {
      Message.error(err.message || '系统异常');
    } else if (res) {
      console.log(res)
      if (res.data == undefined || res.data.length == 0) {
        state.spaceDetails.leaveWordNumber = '0';
        commit('SETLEAVELIST', [])
        commit('SETLEAVEPAGE', state.spaceDetails.pageManagement)
      } else {
        state.spaceDetails.leaveWordNumber = res.pageInfo.total;
        commit('SETLEAVELIST', res.data)
        commit('SETLEAVEPAGE', res.pageInfo)
      }
    }
    return true;
  },


  // 获取背景模板列表
  async findAllBgTemplate({
    commit,
    state,
    dispatch
  }) {
    let [err, res] = await catchErr(_findAllBgTemplate());
    if (err) {
      Message.error(err.message || '系统异常');
    } else if (res) {
      return res
    }
    return true;
  },

  // 获取背景模板列表V2
  async findAllBgTemplateV2({
    commit,
    state,
    dispatch
  }) {
    let [err, res] = await catchErr(_findAllBgTemplateV2());
    if (err) {
      Message.error(err.message || '系统异常');
    } else if (res) {
      return res
    }
    return true;
  },

  // 获取背景模板列表
  async findAllMusicTemplate({
    commit,
    state,
    dispatch
  }) {
    let [err, res] = await catchErr(_findAllMusicTemplate());
    if (err) {
      Message.error(err.message || '系统异常');
    } else if (res) {
      return res
    }
    return true;
  },


  async editById({
    commit,
    state,
    dispatch
  }, params) {
    let [err, res] = await catchErr(_editById({
      data: params
    },params.id));
    if (err) {
      if (err.status == 1069 || err.status == 1054 || err.status == 1098 || err.status == 1040 || err.status == 1117 || err.status == 1015) {
        return err;
      }
      Message.error(err.message || '系统异常');
      return err;
    } else if (res) {
      //console.log(res)
      return res;
    }
    return true;
  },

  async editUpdateStateById({
    commit,
    state,
    dispatch
  }, params) {
    let [err, res] = await catchErr(_editUpdateStateById({
      data: params
    },params.id));
    if (err) {
      if(err.status == 1098 || err.status == 1018 || err.status == 1019){
        return err
      }
      Message.error(err.message || '系统异常');
    } else if (res) {
      //console.log(res)
    }
    return res;
  },

  async editUploadStateById({
    commit,
    state,
    dispatch
  }, params) {
    let [err, res] = await catchErr(_editUploadStateById({
      data: params
    },params.id));
    if (err) {
      if(err.status == 1098 || err.status == 1018 || err.status == 1019){
        return err
      }
      Message.error(err.message || '系统异常');
    } else if (res) {
      //console.log(res)
    }
    return res;
  },

  async editCemeteryById({
    commit,
    state,
    dispatch
  }, params) {
    let [err, res] = await catchErr(_editCemeteryById({
      data: params
    },params.id));
    if (err) {
      if(err.status == 1098){
        return err
      }
      Message.error(err.message || '系统异常');
    } else if (res) {
      //console.log(res)
    }
    return res;
  },

  async editVisitorFrozenById({
    commit,
    state,
    dispatch
  }, params) {
    let [err, res] = await catchErr(_editVisitorFrozenById({
      data: params
    }));
    if (err) {
      Message.error(err.message || '系统异常');
    } else if (res) {
      //console.log(res)
    }
    return res;
  },

  async editSpaceFrozenById({
    commit,
    state,
    dispatch
  }, params) {
    let [err, res] = await catchErr(_editSpaceFrozenById({
      data: params
    },params.id));
    if (err) {
      if(err.status == 1098 || err.status == 1018 || err.status == 1019){
        return err
      }
      Message.error(err.message || '系统异常');
    } else if (res) {
      //console.log(res)
      return res;
    }
    return true;
  },


  async getUrlDataSource({
    commit,
    state,
    dispatch
  }, params) {
    let [err, res] = await catchErr(_getUrlDataSource({
      data: params
    }));
    if (err) {
      //console.log(err)
      return err;
      //Message.error(err.message || '系统异常');
    } else if (res) {
      //console.log(res)
      //return res;
    }

  },

  async cancelUpdateStateById({
    commit,
    state,
    dispatch
  }, params) {
    let [err, res] = await catchErr(_cancelUpdateStateById({
      data: params
    }));
    if (err) {
      //console.log(err)
      return err;
      //Message.error(err.message || '系统异常');
    } else if (res) {
      //console.log(res)
      return res;
    }

  },

  async getUrlConnectionCode({
    commit,
    state,
    dispatch
  }, params) {
    let [err, res] = await catchErr(_getUrlConnectionCode({
      data: params
    }));
    if (err) {
      //console.log(err)
      return err;
      //Message.error(err.message || '系统异常');
    } else if (res) {
      //console.log(res)
      return res;
    }

  },

  async getOssFileState({
    commit,
    state,
    dispatch
  }, params) {
    let [err, res] = await catchErr(_getOssFileState({
      data: params
    }));
    if (err) {
      //console.log(err)
      Message.error(err.message || '系统异常');
      return err;
    } else if (res) {
      //console.log(res)
      return res;
    }

  },

  async cancelUploadStateById({
    commit,
    state,
    dispatch
  }, params) {
    let [err, res] = await catchErr(_cancelUploadStateById({
      data: params
    },params));
    if (err) {
      //console.log(err)
      if(err.status == 1098){
        return err
      }
      Message.error(err.message || '系统异常');
      return err;
    } else if (res) {
      //console.log(res)
      return res;
    }

  },

  async editUploadById({
    commit,
    state,
    dispatch
  }, params) {
    let [err, res] = await catchErr(_editUploadById({
      data: params
    },params.id));
    if (err) {
      if(err.status == 1098){
        return err
      }
      Message.error(err.message || '系统异常');
      return err;
    } else if (res) {
      //console.log(res)
      return res;
    }

  },

  async saveLog({
    commit,
    state,
    dispatch
  }, params) {
    let [err, res] = await catchErr(_saveLog({
      data: params
    },params.dmId));
    if (err) {
      if(err.status == 1098){
        return err
      }
      Message.error(err.message || '系统异常');
      return err;
    } else if (res) {
      return res;
    }

  },

  async editDeadNameById({
    commit,
    state,
    dispatch
  }, params) {
    let [err, res] = await catchErr(_editDeadNameById({
      data: params
    }));
    if (err) {
      Message.error(err.message || '系统异常');
      return false;
    } else if (res) {
      //console.log(res)
    }
    return res;
  },

  async getWxPayOrder({
    commit,
    state,
    dispatch
  }, params) {
    let [err, res] = await catchErr(_getWxPayOrder({
      data: params
    }));
    if (err) {
      Message.error(err.message || '系统异常');
      return false;
    } else if (res) {
      console.log(res)
    }
    return true;
  },

  async delUploadById({
    commit,
    state,
    dispatch
  }, params) {
    let [err, res] = await catchErr(_delUploadById({
      data: params
    },params.dmId));
    if (err) {
      if(err.status == 1098){
        return err
      }
      Message.error(err.message || '系统异常');
      return err;
    } else if (res) {
      return res;
    }
    return true;
  },

  async findPhotoCategory({
    commit,
    state,
    dispatch
  }, params) {
    let [err, res] = await catchErr(_findPhotoCategory({
      data: params
    },params));
    if (err) {
      if(err.status == 1098){
        return err
      }
      Message.error(err.message || '系统异常');
      return err;
    } else if (res) {
      console.log(res)
      commit('PHOTOCATEGORYLIST', res.data)
      return true;
    }
    return true;
  },

  async addOrEditPhotoCategory({
    commit,
    state,
    dispatch
  }, params) {
    let [err, res] = await catchErr(_addOrEditPhotoCategory({
      data: params
    },params.dmId));
    if (err) {
      if(err.status == 1098 || err.status == 1086){
        return err
      }
      Message.error(err.message || '系统异常');
      return err;
    } else if (res) {
      return res;
    }
    return true;
  },

  async delPhotoCategory({
    commit,
    state,
    dispatch
  }, params) {
    let [err, res] = await catchErr(_delPhotoCategory({
      data: params
    },params.dmId));
    if (err) {
      if(err.status == 1098 || err.status == 1086 || err.status == 1111){
        return err
      }
      Message.error(err.message || '系统异常');
      return err;
    } else if (res) {
      return res;
    }
    return true;
  },

  async findPhotoByCategoryId({
    commit,
    state,
    dispatch
  }, params) {
    let [err, res] = await catchErr(_findPhotoByCategoryId({
      data: params.data,
      pageInfo: params.pageInfo
    },params.data.dmId));
    if (err) {
      if(err.status == 1098){
        return err
      }
      Message.error(err.message || '系统异常');
      return err;
    } else if (res) {
      return res;
    }
    return true;
  },

  async addPhotoByCategoryId({
    commit,
    state,
    dispatch
  }, params) {
    let [err, res] = await catchErr(_addPhotoByCategoryId({
      data: params,
    },params.id));
    if (err) {
      if(err.status == 1098){
        return err
      }
      Message.error(err.message || '系统异常');
      return err;
    } else if (res) {
      return res;
    }
    return true;
  },

  async delPhotoById({
    commit,
    state,
    dispatch
  }, params) {
    let [err, res] = await catchErr(_delPhotoById({
      data: params,
    },params.dmId));
    if (err) {
      if(err.status == 1098){
        return err
      }
      Message.error(err.message || '系统异常');
      return err;
    } else if (res) {
      return res;
    }
    return true;
  },

  async editPhotoRemark({
    commit,
    state,
    dispatch
  }, params) {
    let [err, res] = await catchErr(_editPhotoRemark({
      data: params,
    },params.dmId));
    if (err) {
      if(err.status == 1098){
        return err
      }
      Message.error(err.message || '系统异常');
      return err;
    } else if (res) {
      return res;
    }
    return true;
  },

  async editPhotoPosition({
    commit,
    state,
    dispatch
  }, params) {
    let [err, res] = await catchErr(_editPhotoPosition({
      data: params,
    },params.dmId));
    if (err) {
      if(err.status == 1098){
        return err
      }
      Message.error(err.message || '系统异常');
      return err;
    } else if (res) {
      return res;
    }
    return true;
  },
  
  async findMovePhotoCategory({
    commit,
    state,
    dispatch
  }, params) {
    let [err, res] = await catchErr(_findMovePhotoCategory({
      data: params,
    },params.dmId));
    if (err) {
      if(err.status == 1098){
        return err
      }
      Message.error(err.message || '系统异常');
      return err;
    } else if (res) {
      return res;
    }
    return true;
  },

  async movePhoto({
    commit,
    state,
    dispatch
  }, params) {
    let [err, res] = await catchErr(_movePhoto({
      data: params,
    },params.dmId));
    if (err) {
      if(err.status == 1098){
        return err
      }
      Message.error(err.message || '系统异常');
      return err;
    } else if (res) {
      return res;
    }
    return true;
  },

  async dragPhoto({
    commit,
    state,
    dispatch
  }, params) {
    let [err, res] = await catchErr(_dragPhoto({
      data: params,
    },state.spaceDetails.details.id));
    if (err) {
      if(err.status == 1098){
        return err
      }
      Message.error(err.message || '系统异常');
      return err;
    } else if (res) {
      return res;
    }
    return true;
  },
  


  async getUserCount({
    commit,
    state,
    dispatch
  }, params) {
    let [err, res] = await catchErr(_getUserCount({
      data: params,
    }));
    if (err) {
      if(err.status == 1098){
        return err
      }
      Message.error(err.message || '系统异常');
      return err;
    } else if (res) {
      return res;
    }
    return true;
  },


  async getCoverVideo({
    commit,
    state,
    dispatch
  }, params) {
    let [err, res] = await catchErr(_getCoverVideo({
      data: params,
    }));
    if (err) {
      if(err.status == 1098){
        return err
      }
      Message.error(err.message || '系统异常');
      return err;
    } else if (res) {
      return res;
    }
    return true;
  },

  async getClaimCodeUrl({
    commit,
    state,
    dispatch
  }, params) {
    let [err, res] = await catchErr(_getClaimCodeUrl({
      data: params
    }));
    if (err) {
      Message.error(err.message || '系统异常');
    } else if (res) {
      //console.log(res)
    }
    return res;
  },

  async getClaimCodeUrlAll({
    commit,
    state,
    dispatch
  }, params) {
    let [err, res] = await catchErr(_getClaimCodeUrlAll({
      data: params
    }));
    if (err) {
      Message.error(err.message || '系统异常');
    } else if (res) {
      //console.log(res)
    }
    return res;
  },

  async getLifeAlbumByDmId({
    commit,
    state,
    dispatch
  }, params = "") {
    let [err, res] = await catchErr(_getLifeAlbumByDmId({
      data: params
    },params.dmId));
    if (err) {
      if(err.status == 1098){
        messageBoxDeadManDel();
        return;
      }
      Message.error(err.message || '系统异常');
      return err;
    } else if (res) {
      return res;
    }
  },

  async findLifeAlbumPhotoAllByDmId({
    commit,
    state,
    dispatch
  }, params = "") {
    let [err, res] = await catchErr(_findLifeAlbumPhotoAllByDmId({
      data: params
    },params.dmId));
    if (err) {
      if(err.status == 1098){
        messageBoxDeadManDel();
        return;
      }
      Message.error(err.message || '系统异常');
      return err;
    } else if (res) {
      return res;
    }
  },

  async addLifeAlbumPhotoByDmId({
    commit,
    state,
    dispatch
  }, params = "") {
    let [err, res] = await catchErr(_addLifeAlbumPhotoByDmId({
      data: params
    },params.dmId));
    if (err) {
      if(err.status == 1098){
        messageBoxDeadManDel();
        return;
      }
      Message.error(err.message || '系统异常');
      return err;
    } else if (res) {
      return res;
    }
  },

  async draggableLifeAlbumPhoto({
    commit,
    state,
    dispatch
  }, params = "") {
    let [err, res] = await catchErr(_draggableLifeAlbumPhoto({
      data: params
    },params.dmId));
    if (err) {
      if(err.status == 1098){
        messageBoxDeadManDel();
        return;
      }
      Message.error(err.message || '系统异常');
      return err;
    } else if (res) {
      return res;
    }
  },

  async delLifeAlbumPhotoByIds({
    commit,
    state,
    dispatch
  }, params = "") {
    let [err, res] = await catchErr(_delLifeAlbumPhotoByIds({
      data: params
    },params.dmId));
    if (err) {
      if(err.status == 1098){
        messageBoxDeadManDel();
        return;
      }
      Message.error(err.message || '系统异常');
      return err;
    } else if (res) {
      return res;
    }
  },

  async findLifeAlbumTemplateBg({
    commit,
    state,
    dispatch
  }, params = "") {
    let [err, res] = await catchErr(_findLifeAlbumTemplateBg({
      data: params
    },params.dmId));
    if (err) {
      if(err.status == 1098){
        messageBoxDeadManDel();
        return;
      }
      Message.error(err.message || '系统异常');
      return err;
    } else if (res) {
      return res;
    }
  },

  async findLifeAlbumTemplateMusic({
    commit,
    state,
    dispatch
  }, params = "") {
    let [err, res] = await catchErr(_findLifeAlbumTemplateMusic({
      data: params
    },params.dmId));
    if (err) {
      if(err.status == 1098){
        messageBoxDeadManDel();
        return;
      }
      Message.error(err.message || '系统异常');
      return err;
    } else if (res) {
      return res;
    }
  },

  async findLifeAlbumSubtitle1({
    commit,
    state,
    dispatch
  }, params = "") {
    let [err, res] = await catchErr(_findLifeAlbumSubtitle1({
      data: params
    },params.dmId));
    if (err) {
      if(err.status == 1098){
        messageBoxDeadManDel();
        return;
      }
      Message.error(err.message || '系统异常');
      return err;
    } else if (res) {
      return res;
    }
  },

  async findLifeAlbumSubtitle2({
    commit,
    state,
    dispatch
  }, params = "") {
    let [err, res] = await catchErr(_findLifeAlbumSubtitle2({
      data: params
    },params.dmId));
    if (err) {
      if(err.status == 1098){
        messageBoxDeadManDel();
        return;
      }
      Message.error(err.message || '系统异常');
      return err;
    } else if (res) {
      return res;
    }
  },

  async findLifeAlbumSubtitle3({
    commit,
    state,
    dispatch
  }, params = "") {
    let [err, res] = await catchErr(_findLifeAlbumSubtitle3({
      data: params
    },params.dmId));
    if (err) {
      if(err.status == 1098){
        messageBoxDeadManDel();
        return;
      }
      Message.error(err.message || '系统异常');
      return err;
    } else if (res) {
      return res;
    }
  },

  async addLifeAlbumByDmId({
    commit,
    state,
    dispatch
  }, params = "") {
    let [err, res] = await catchErr(_addLifeAlbumByDmId({
      data: params
    },params.dmId));
    if (err) {
      if(err.status == 1098){
        messageBoxDeadManDel();
        return;
      }
      Message.error(err.message || '系统异常');
      return err;
    } else if (res) {
      return res;
    }
  },

  async addLifeAlbumListener({
    commit,
    state,
    dispatch
  }, params = "") {
    let [err, res] = await catchErr(_addLifeAlbumListener({
      data: params
    },params.dmId));
    if (err) {
      if(err.status == 1098){
        messageBoxDeadManDel();
        return;
      }
      Message.error(err.message || '系统异常');
      return err;
    } else if (res) {
      return res;
    }
  },
  
  async cleanLifeAlbumByDmId({
    commit,
    state,
    dispatch
  }, params = "") {
    let [err, res] = await catchErr(_cleanLifeAlbumByDmId({
      data: params
    },params.dmId));
    if (err) {
      if(err.status == 1098){
        messageBoxDeadManDel();
        return;
      }
      Message.error(err.message || '系统异常');
      return err;
    } else if (res) {
      return res;
    }
  },
  
  async updateLifeAlbumStateByDmId({
    commit,
    state,
    dispatch
  }, params = "") {
    let [err, res] = await catchErr(_updateLifeAlbumStateByDmId({
      data: params
    },params.dmId));
    if (err) {
      if(err.status == 1098){
        messageBoxDeadManDel();
        return;
      }
      Message.error(err.message || '系统异常');
      return err;
    } else if (res) {
      return res;
    }
  },

  async findLifeAlbumPhotoFrameById({
    commit,
    state,
    dispatch
  }, params = "") {
    let [err, res] = await catchErr(_findLifeAlbumPhotoFrameById({
      data: params
    },params.dmId));
    if (err) {
      if(err.status == 1098){
        messageBoxDeadManDel();
        return;
      }
      Message.error(err.message || '系统异常');
      return err;
    } else if (res) {
      return res;
    }
  },

  async editLifeAlbumPhotoCropperUrl({
    commit,
    state,
    dispatch
  }, params = "") {
    let [err, res] = await catchErr(_editLifeAlbumPhotoCropperUrl({
      data: params
    },params.dmId));
    if (err) {
      if(err.status == 1098){
        messageBoxDeadManDel();
        return;
      }
      Message.error(err.message || '系统异常');
      return err;
    } else if (res) {
      return res;
    }
  },

  async cancelLifeAlbumPhotoCropperUrl({
    commit,
    state,
    dispatch
  }, params = "") {
    let [err, res] = await catchErr(_cancelLifeAlbumPhotoCropperUrl({
      data: params
    },params.dmId));
    if (err) {
      if(err.status == 1098){
        messageBoxDeadManDel();
        return;
      }
      Message.error(err.message || '系统异常');
      return err;
    } else if (res) {
      return res;
    }
  },
  
  async editLifeAlbumPhotoAiUrl({
    commit,
    state,
    dispatch
  }, params = "") {
    let [err, res] = await catchErr(_editLifeAlbumPhotoAiUrl({
      data: params
    },params.dmId));
    if (err) {
      if(err.status == 1098){
        messageBoxDeadManDel();
        return;
      }
      Message.error(err.message || '系统异常');
      return err;
    } else if (res) {
      return res;
    }
  },
    
  async confirmLifeAlbumPhotoAiUrl({
    commit,
    state,
    dispatch
  }, params = "") {
    let [err, res] = await catchErr(_confirmLifeAlbumPhotoAiUrl({
      data: params
    },params.dmId));
    if (err) {
      if(err.status == 1098){
        messageBoxDeadManDel();
        return;
      }
      Message.error(err.message || '系统异常');
      return err;
    } else if (res) {
      return res;
    }
  },

  async replaceLifeAlbumPhotoAiUrl({
    commit,
    state,
    dispatch
  }, params = "") {
    let [err, res] = await catchErr(_replaceLifeAlbumPhotoAiUrl({
      data: params
    },params.dmId));
    if (err) {
      if(err.status == 1098){
        messageBoxDeadManDel();
        return;
      }
      Message.error(err.message || '系统异常');
      return err;
    } else if (res) {
      return res;
    }
  },
    
  async replaceLifeAlbumPhotoAiUrlAll({
    commit,
    state,
    dispatch
  }, params = "") {
    let [err, res] = await catchErr(_replaceLifeAlbumPhotoAiUrlAll({
      data: params
    },params.dmId));
    if (err) {
      if(err.status == 1098){
        messageBoxDeadManDel();
        return;
      }
      Message.error(err.message || '系统异常');
      return err;
    } else if (res) {
      return res;
    }
  },

  async uploadLifeAlbumVideoToDmPhoto({
    commit,
    state,
    dispatch
  }, params = "") {
    let [err, res] = await catchErr(_uploadLifeAlbumVideoToDmPhoto({
      data: params
    },params.dmId));
    if (err) {
      if(err.status == 1098){
        messageBoxDeadManDel();
        return;
      }
      Message.error(err.message || '系统异常');
      return err;
    } else if (res) {
      return res;
    }
  },
  
  async downloadLifeAlbumVideo({
    commit,
    state,
    dispatch
  }, params = "") {
    let [err, res] = await catchErr(_downloadLifeAlbumVideo({
      data: params
    },params.dmId));
    if (err) {
      if(err.status == 1098){
        messageBoxDeadManDel();
        return;
      }
      Message.error(err.message || '系统异常');
      return err;
    } else if (res) {
      return res;
    }
  },
  
  async compositeLifeAlbumPhotoAiHeadPic({
    commit,
    state,
    dispatch
  }, params = "") {
    let [err, res] = await catchErr(_compositeLifeAlbumPhotoAiHeadPic({
      data: params
    },params.dmId));
    if (err) {
      if(err.status == 1098){
        messageBoxDeadManDel();
        return;
      }
      Message.error(err.message || '系统异常');
      return err;
    } else if (res) {
      return res;
    }
  },
    
  async callLifeAlbumPhotoAi({
    commit,
    state,
    dispatch
  }, params = "") {
    let [err, res] = await catchErr(_callLifeAlbumPhotoAi({
      data: params
    },params.dmId));
    if (err) {
      if(err.status == 1098){
        messageBoxDeadManDel();
        return;
      }
      Message.error(err.message || '系统异常');
      return err;
    } else if (res) {
      return res;
    }
  },
  
  async uploadLifeAlbumPhotoToDmPhoto({
    commit,
    state,
    dispatch
  }, params = "") {
    let [err, res] = await catchErr(_uploadLifeAlbumPhotoToDmPhoto({
      data: params
    },params.dmId));
    if (err) {
      if(err.status == 1098){
        messageBoxDeadManDel();
        return;
      }
      Message.error(err.message || '系统异常');
      return err;
    } else if (res) {
      return res;
    }
  },
}





// WEBPACK FOOTER //
// ./src/store/modules/SpaceManagement/actions.js